(() => {
  const paint = () => {
    const c = window.NSClubAPI?.state;
    if (!c) return;
    document.querySelectorAll('[data-ns-club-premium]').forEach(card => {
      card.dataset.nsClubReady = 'true';
      card.dataset.nsClubBalanceReady = String(c.balanceReady !== false);
      if (!c.logged) return;
      const balance = card.querySelector('[data-ns-club-balance]');
      const status = card.querySelector('[data-ns-club-status]');
      if (c.balanceReady === false) {
        balance.textContent = 'Saldo pendiente';
        status.textContent = 'No hemos podido consultar tus fichas. Vuelve a cargar la página o contacta con nosotros.';
        return;
      }
      balance.textContent = `${c.shown} / ${c.goal}`;
      card.querySelector('[data-ns-club-stamps]').setAttribute('aria-label', `${c.shown} de ${c.goal} fichas`);
      card.querySelectorAll('[data-ns-club-stamps] li').forEach((li,i) => li.classList.toggle('is-filled',i<c.shown));
      status.textContent = c.state === 'owed' ? 'Tienes una sorpresa desbloqueada para tu próximo pedido de NasoStrips.' : c.state === 'done' ? 'Ya has recibido tu recompensa.' : `Te ${c.goal-c.fill===1?'falta':'faltan'} ${c.goal-c.fill} ${c.goal-c.fill===1?'ficha':'fichas'} para tu siguiente sorpresa.`;
    });
  };
  document.addEventListener('ns:club-ready',paint);
  document.addEventListener('shopify:section:load',paint);
  paint();
})();
